import { z } from 'zod'

export const userRoleSchema = z.enum(['admin', 'manager', 'member'])
export type UserRole = z.infer<typeof userRoleSchema>

export const userRoleLabels: Record<UserRole, string> = {
  admin: 'システム管理者',
  manager: '管理者',
  member: '一般ユーザー',
}

export const userRoleOptions = Object.entries(userRoleLabels).map(([key, label]) => ({
  value: key,
  label,
}))

export const userRoleColors: Record<UserRole, string> = {
  admin: 'yellow',
  manager: 'blue',
  member: 'green',
}
